import React from "react";
import Loading from "../../../../../ReusableFunctions/Loader";
import Popup from "../../../../../ReusableFunctions/Popup";
import Modal from "../../../../../ReusableComponents/Modal";
import Form from "../../../../../ReusableComponents/Form";
import InputField from "../../../../../ReusableComponents/InputField";
import { Button } from "../../../../../Components/Helper";
import SelectField from "../../../../../ReusableComponents/SelectField";
import { updateDspCurrency, updateDSPSettingsFun, updateDspUnits } from "../../../../../apis/users";

const EditAreaUnits = ({ open, onClose, dsp, onUserUpdate }) => {
 const AreaUnitsList=[
 { label: "Acre",    value: "Acre" },
{ label: "Hectare", value: "Hectare" }
 ]
  const EditAreasUnitsData = async (dspDetails) => {
  if (dspDetails?.units && dspDetails.id) {
    try {
      Loading.set(true);
      const res = await updateDSPSettingsFun({ units: dspDetails.units });
   onUserUpdate({
  ...dsp,
  settings: {
    ...dsp?.settings,
    ...res?.updatedSettings,   
  }})
      
      Loading.set(false);
      Popup.alert("SUCCESS", "Area Units Updated", "SUCCESS", onClose);
    } catch (e) {
      Loading.set(false);
      Popup.alert("Error", e || "Something went wrong.", "ERROR");
    }
  }
};
  return (
    <Modal
      header={"Add Units"}
      open={open}
      onClose={onClose}
      contentStyle={{ width: "574px", height: "250px" }}
      divider={true}
      headingStyle={{ fontSize: "18px" }}
      iconSize={"18px"}
      headerContainerStyle={{ padding: "20px 40px" }}
    >
      <Form
        onSubmitForm={(data) => {
          if (!dsp?.id) {
            console.log("DSP missing", dsp);
            return;
          }
          const { units } = data;
        //   EditCurrencyData({
        //     invoice_currency: invoice_currency?.value,
        //     id: dsp?.id,
        //   });
        EditAreasUnitsData({
            units:units?.value,
            id:dsp?.id

        })
        }}
        style={{
          padding: "15px 40px 20px",
          display: "flex",
          flexDirection: "column",
          gap: "1.1rem",
        }}
      >
        {(onSubmit) => (
          <>
            <SelectField
              label={"Units"}
              name={"units"}
              placeholder={"select units"}
              required={true}
              list={AreaUnitsList}
              style={{
                height: "51px",
                borderRadius: "8px",
                padding: "2px 15px",
              }}
              inputStyle={{ fontSize: "16px" }}
              // validation={taxPercentageValidation}
              labelStyle={{
                paddingBottom: "7px",
                fontSize: "16px",
                color: "#3b3b3b",
                fontWeight: "400",
              }}
              // defaultValue={currencyList.find((c) => c.value === dsp?.currency)}
              defaultValue={AreaUnitsList.find(
                (c) => c.value === dsp?.units,
              )}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                gap: "15px",
              }}
            >
              <Button
                type={"submit"}
                text="Update"
                style={{ width: "110px", height: "40px", fontSize: "16px" }}
                onClick={() => onSubmit()}
              />
              <Button
                type={"button"}
                onClick={() => {
                  onClose();
                }}
                text={"Cancel"}
                isBtnNotActive={true}
                style={{ width: "110px", height: "40px", fontSize: "16px" }}
              />
            </div>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default EditAreaUnits;
